import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-expandable-section',
    templateUrl: './expandable-section.component.html',
    styleUrls: ['./expandable-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExpandableSectionComponent {
  @Input() title = '';
  @Input() expanded = false;
  @Input() showChangeIndicator = false;

  @Output() expandedChange = new EventEmitter<boolean>();

  toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
